/**
 * Module dependencies.
 */

import {
  acceptLanguageHeader,
  handleRequestError,
  request
} from 'src/core/utils/requests';

import { getApiEndpoint } from 'src/core/utils/api-url-resolver';

/**
 * `Query` type.
 */

type Query = {
  formData: {
    company: string;
    country: string;
    email: string;
    gas_type?: string | null;
    message?: string | null;
    name: string;
    phone?: string | null;
    position?: string | null;
    recaptcha_token: string;
    subject: string;
    subscribe_to_newsletter: boolean;
    technology_type?: string[] | null;
  };
  locale: string;
};

/**
 * Export `submitContactForm`.
 */

export async function submitContactForm({ formData, locale }: Query) {
  const endpoint = getApiEndpoint('submitContactUsForm');

  try {
    const { data } = await request.post(endpoint, formData, {
      headers: acceptLanguageHeader(locale)
    });

    return data?.data;
  } catch (error) {
    throw handleRequestError(error);
  }
}
